<template>
    <div
      class="fill-height"
      :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 280px; padding-top: 128px;` : `padding-bottom: 650px; padding-top: 64px;`">
      <v-layout wrap>
        <v-flex>
          <section>
            <div>
              <!-- <v-card
                v-if="process.load"
                flat
                height="250"
                width="100vw"
                color="#00000040">
                <v-skeleton-loader
                  :loading="process.load"
                  transition="scale-transition"
                  :tile="false"
                  class="ma-auto load_card_x_large"
                  type="image"
                  style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
                </v-skeleton-loader>
              </v-card> -->
              <div v-if="!process.list">
                  <!-- <v-card
                    flat
                    cover
                    v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' "
                    class="background-default">
                    <v-img :src="require('@/assets/image/Candi-Prambanan.jpg')" width="100%" height="250" style="opacity: 0.75;" :gradient="`to right, ${set_color_rgb_up}, #000000a6`" class="img_center align-center">
  
                      <div class="d-flex align-center justify-center font-weight-black">
                        <div class="text-center">
                          <div
                            class="text-h4 white--text justify-center mb-2 pt-6"
                            style="font-weight: 500;">
                            {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span>
                          </div>
  
                          <div
                            class="body-1 white--text text-center mb-4"
                            style="opacity: 50%; font-weight: 500;">
                            Mengenal {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span> di kabupaten Klaten.
                          </div>
                        </div>
                      </div>
  
                    </v-img>
                  </v-card> -->
              </div>
            </div>
            <v-container>
              <!-- <v-row>
                <v-col
                  cols="12">
                  <v-card
                    flat
                    class="background-default">
                    <v-card-title
                      class="text-h4 white--text justify-center mb-2 pt-6"
                      style="font-weight: 500;">
                      Berita
                    </v-card-title>
  
                    <v-card-subtitle
                      class="body-1 white--text text-center mb-4"
                      style="opacity: 50%; font-weight: 500;">
                      Jangan ketinggalan berita yang ada di Klaten.
                    </v-card-subtitle>
  
                    <v-card-text>
                      <v-row
                        class="mb-5"
                        justify="center">
                        <v-col
                          cols="6">
                        </v-col>
                        <v-col
                          cols="6">
                          <v-text-field
                            v-model="search"
                            @click:clear="search = ''; fetch();"
                            v-on:keyup.enter="fetch()"
                            dense
                            rounded
                            solo
                            single-line
                            placeholder="Cari data yang Anda butuhkan . . ."
  
                            hide-details
                            clearable
  
                            class="form_white"
                            :color="set_color"
                            append-icon="mdi-magnify">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row> -->
  
              <div>
                <v-row>
                  <!-- <v-col cols="12" md="3">
                    <v-skeleton-loader
                      :loading="process.load"
                      v-if="process.load"
                      transition="scale-transition"
                      :tile="false"
                      class="ma-auto load_card_x_large"
                      type="image"
                      style="width: 100% !important; height: 800px !important; min-height: 800px !important;">
                    </v-skeleton-loader>
                    <v-card
                      class="mx-auto"
                      v-if="!process.load"
                      style="border-radius: 15px;"
                      min-height="100%"
                      :class="'elevation-0'"
                      >
                      <v-card-title>
                        <div class="font-weight-medium" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'  ? 'text-h6' : 'body-1 text-center w-100'">
                          <span>Kategori</span> Berita
                        </div>
                      </v-card-title>
                      <v-list flat v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                        <v-list-item-group
                          v-model="selected.category"
                          mandatory
                          :color="set_color"
                        >
                          <v-list-item
                            v-for="(item, i) in category"
                            :key="i"
                            @click="selected.category = i; changeQuery(item.category_name); fetch(item.id)"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-img
                                width="40px"
                                alt="Kabupaten Klaten"
                                :src="item.category_icon_url === '' ? require('@/assets/image/no-photo.png') : item.category_icon_url">
                              </v-img>
                            </v-list-item-icon>
  
                            <v-list-item-content>
                              <v-list-item-title>{{ item.category_title }}</v-list-item-title>
                            </v-list-item-content>
  
                            <v-list-item-action class="ml-0 my-0">
                              <v-chip
                                class="ma-2"
                                small
                                style="min-width: 40px; text-align: center; justify-content: center;"
                                text-color="white"
                                :color="`${set_color}`"
                              >
                                {{ item.count }}
                              </v-chip>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                      <v-slide-group
                        v-model="selected.category"
                        class="px-0 pb-5"
                        mandatory
                        show-arrows
                        v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
                      >
                        <v-slide-item
                          v-for="n in category"
                          :key="n"
                          v-slot="{ active }"
                        >
                        <v-btn
                            class="mx-2 text-capitalize"
                            :input-value="active"
                            :color="active ? `${set_color}` : ``"
                            :active-class="`white--text`"
                            depressed
                            rounded
                            @click="selected.category = i; changeQuery(n.category_name); fetch(n.id)"
                          >
                            {{ n.category_title }}
                          </v-btn>
                        </v-slide-item>
                      </v-slide-group>
                    </v-card>
                  </v-col> -->
                  <v-col cols="12" md="9" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? '' : 'pt-0'">
                    <!-- <v-row>
                      <v-col
                        v-for="(item, index) in process.load || process.list ? 8 : list"
                        :key="index"
                        :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 6 : 12"
                        md="4">
                        <v-skeleton-loader
                          :loading="process.load || process.list"
                          transition="scale-transition"
                          :tile="false"
                          class="ma-auto"
                          type="card">
                          <div>
                            <div v-if="!process.list && !process.load && list.length > 0"
                              class="border-radius">
                              <v-card
                                :to="`/pengumuman/${item.slug}?q=${item.id}`"
                                style="border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.01) 0px 3px 5px;"
                                width="100%">
                                <v-img
                                  contain
                                  :height="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'  ? 130 : 250"
                                  alt="Pemerintah Kabupaten Klaten"
                                  :src="item.image_url_cover === '' ? item.image_url === '' ? require('@/assets/image/no-photo.png') : item.image_url : item.image_url_cover"
                                  class="ma-auto">
  
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
  
                                <div class="pa-3">
                                  <div class="body-2 font-weight-bold one-line">
                                    {{ item.title }}
                                  </div>
  
                                  <div class="d-flex align-center mt-1">
                                    <v-icon small color="#212121">mdi-account-circle-outline</v-icon>
  
                                    <span class="caption one-line ml-1">
                                      Admin
                                    </span>
  
                                  </div>
  
                                  <div class="caption font-weight-light three-line my-2" style="opacity: 60%; min-height: 60px; height: 60px; max-height: 60px;">
                                    <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                  </div>
  
                                  <v-divider class="my-2" style="border: 2px solid #f9f9f9;" />
  
                                  <div class="caption d-flex align-center" style="opacity: 60%;">
                                    <div>
                                      {{ item.publish_datetime | date }}
                                    </div>
                                  </div>
                                </div>
                              </v-card>
                            </div>
                          </div>
                        </v-skeleton-loader>
                      </v-col>
                    </v-row> -->

                    <div class="body-1 font-weight-medium mb-5" :style="`color: ${set_color}`">
                      DOKUMEN PERENCANAAN
                    </div>
  
  
                    <v-card flat
                      style="border-radius: 6px;"
                      class="mb-5">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.list"
                        type="list-item-three-line">
                        <div>
                          <div v-if="!process.list && list.length > 0">
                            <v-list style="min-height: 80vh">
                              <v-list-item
                                v-for="(item, index) in list"
                                :key="index"
                                @click="openDocument(item)"
                                style="cursor: pointer"
                                class="px-4 py-2">
                                <v-list-item-content>
                                  <div class="d-flex align-start">
                                    <span class="body-1 font-weight-medium mr-3">
                                      {{ index + 1 }}.
                                    </span>
                                    <span class="body-1 doc-list-item" @mouseover="voiceHover(item.title)">
                                      {{ item.title }}
                                    </span>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </div>
                        </div>
                      </v-skeleton-loader>
                    </v-card>
  
                    <!-- <div v-if="!process.list && pagination.total_data > 12 && limit < pagination.total_data"
                      class="text-center mt-4 mb-2">
                      <v-btn
                        @click="limit += 12"
                        :loading="process.limit"
                        small
                        rounded
                        outlined
                        elevation="0"
                        :color="set_color"
                        @mouseover="voiceHover('Lebih Banyak')"
                        class="text-capitalize"
                        style="opacity: 60%;">
                        Lebih banyak
                      </v-btn>
                    </div> -->
  
                    <Empty v-if="!process.list && pagination.total_page < 1"
                      class="py-12"
                      margin="my-16"
                      size="125"
                      message="Dokumen Perencanaan" />
  
                  </v-col>
                  <v-col cols="12" md="3">
  
                    <Sidebar />
                  </v-col>
                </v-row>
              </div>
  
  
            </v-container>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { createSEOMeta } from '@/utils/seo'
    export default {
      middleware: false,
      data () {
        return {
          search: '',
          category: [
            {
              icon: 'mdi-newspaper',
              text: 'IPKD',
              link: '/IPKD?category=utama'
            },
            {
              icon: 'mdi-newspaper-variant',
              text: 'IPKD OPD',
              link: '/IPKD?category=opd'
            },
            {
              icon: 'mdi-newspaper-variant-outline',
              text: 'IPKD Wilayah',
              link: '/IPKD?category=wilayah'
            },
          ],
          selected: {
            category: 0
          },
          filter: {
            category: ''
          },
          total_category: 0,
          list: [],
          pagination: {},
  
          limit: 12,
  
          process: {
            load: false,
  
            limit: false,
  
            list: false
          },
          message: {
            success: '',
            error: ''
          },
          // SEO
          content: {
            url: '/dokumen-perencanaan',
            title: 'Dokumen Perencanaan',
            description: 'Dokumen Perencanaan Kabupaten Klaten',
            image: require('@/assets/logo/favicon.png')
          }
        }
      },
      head () {
        return {
          title: this.content.title,
          meta: createSEOMeta(this.content)
        }
      },
      // components: {
      //   Utama: () => import(/* webpackPrefetch: true */ '@/components/berita/utama.vue'),
      //   OPD: () => import(/* webpackPrefetch: true */ '@/components/berita/opd.vue'),
      //   Wilayah: () => import(/* webpackPrefetch: true */ '@/components/berita/wilayah.vue'),
      // },
      components: {
        Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
        Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
      },
      watch: {
        'limit': function() {
          this.process.limit = true
  
          this.fetch('limit')
        },
        // '$route.query.category': function(val) {
        //   this.changeLink(val)
        // },
        // '$route.query.search': function(val) {
        //   this.changeLink()
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.member.auth.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          console.log(this.$store.state.header.config.color)
          return this.$store.state.header.config.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        // this.fetchCategory()
        this.fetch()
      },
      methods: {
        voiceHover (item) {
          responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
          responsiveVoice.speak(item, 'Indonesian Female');
        },
        openDocument(item) {
          let url = ''
          if (item.link && item.link !== '') {
            url = item.link
          } else if (item.file_url && item.file_url !== '') {
            url = item.file_url
          }
          
          if (url) {
            window.open(url, '_blank')
          }
        },
        // async fetchCategory (id, type) {
        //   this.process.load = type === undefined ? true : false
        //   this.process.list = true
  
        //   let params = {
        //     limit: 1000000,
        //     par_id: '1'
        //   }
  
        //   await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
        //   .then(response => {
        //     let res = response
  
        //     if (res.status === 200) {
        //       this.category = [
        //         {
        //           category_title: "Semua Kategori",
        //           category_icon_url: require('@/assets/icon/app.png'),
        //           id: '',
        //           category_name: "semua-kategori",
        //           count: 0
        //         }
        //       ]
        //       let category = []
        //       category = res.results.data.map(item => {
        //           const container = {};
  
        //           container.category_title = item.title;
        //           container.category_icon_url = item.icon_url;
        //           container.id = item.id;
        //           container.category_name = item.slug;
        //           container.count = item.count
  
        //           // this.category = container;
        //           return container
        //         })
  
  
        //       for (let i in category) {
        //         this.category.push(
        //           {
        //             category_title: category[i].category_title,
        //             category_icon_url: category[i].category_icon_url,
        //             id: category[i].id,
        //             category_name: category[i].category_name,
        //             count: category[i].count
        //           }
        //         )
  
        //       }
  
        //       for (let i in this.category) {
        //         this.total_category += parseInt(this.category[i].count)
  
        //       }
  
        //       this.process.load = false
        //       this.category[0].count = this.total_category
        //       // this.changeLink()
        //     }
        //   })
        // },
        async fetch () {
          this.process.list = this.process.limit ? false : true
  
          let params = {
            limit: 100000000,
            // 'category_id': '19',
            // filter: `par_id!=2`,
  
            // sort: 'publish_datetime',
  
            // category_id: this.filter.category
          }
  
          await this.$axios.$get(`${process.env.API}sites/perencanaan/data`, { params })
          .then(response => {
            let res = response
  
  
            this.process.limit = false
  
            if (res.status === 200) {
              this.list = res.results.data
              this.pagination = res.results.pagination
  
            }
            this.process.list = false
            this.process.load = false
          })
        },
        // changeLink() {
        //   window.scrollTo({
        //     top: 0,
        //     behavior: 'smooth'
        //   })
        //   let status = false
        //   let id = 0
        //   this.selected.category = 0
        //   this.filter.category = ''
  
  
        //   if (this.$route.query.category !== undefined) {
        //     for(let i = 0; i < this.category.length; i++){
        //       if (this.category[i].category_name === this.$route.query.category) {
        //         this.filter.category = this.category[i].id
        //         this.selected.category = i
        //         status = true
        //       } else {
        //         // status = false
        //       }
        //     }
        //     // if (query === 'wisata') {
        //     //     this.selected = {
        //     //       category: 0,
        //     //     }
        //     // } else if (query === 'kuliner') {
        //     //   this.selected = {
        //     //     category: 1
        //     //   }
        //     // }
        //     // this.fetch(id)
        //   }
        //   // console.log(status)
        //   if (status === false) {
        //     this.$router.push(`/pengumuman`)
        //   }
  
        //   console.log(id)
  
        //   this.fetch()
        // },
        // changeQuery(name) {
        //   if(name === '') {
        //     if (this.$route.query.search !== undefined) {
        //       this.$router.replace({'path': `/berita`, 'query': {'search': this.$route.query.search}})
        //     } else {
        //       this.$router.replace({'path': `/berita`})
        //     }
        //   } else {
        //     if (this.$route.query.search === undefined) {
        //       this.$router.replace({'path': `/berita`, 'query': {'category': name}})
        //     } else {
        //       this.$router.replace({'path': `/berita`, 'query': {'category': name, 'search': this.$route.query.search}})
        //     }
        //   }
        // },
        // toDetail(item) {
        //   this.$router.push(`/pengumuman/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
        // },
      }
    }
  </script>

  <style scoped>
  .doc-list-item:hover {
    color: #d32f2f !important;
  }
  </style>
  